import { render, staticRenderFns } from "./NotificationSave.vue?vue&type=template&id=7382d997&"
import script from "./NotificationSave.vue?vue&type=script&lang=js&"
export * from "./NotificationSave.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSave.vue?vue&type=style&index=0&id=7382d997&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports